/**
 *
 * Azure Active Directory
 *
 */

import React from 'react';

import { CloudProviders } from '@ariksa/cloud-account/api';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Form } from 'components/DataEntry/Form';
import { selectSetup } from 'containers/Setup/selectors';
import { actions as setupActions } from 'containers/Setup/slice';

import { formStyles } from '../../../../../Integrations/styles';

export const UpdateAzureAD = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { activeAccount } = useSelector(selectSetup);

  const handleReset = () => {
    navigate('/setup/accounts');
  };
  const handleSubmit = data => {
    const { name } = data;
    dispatch(
      setupActions.updateCloudAccount({
        q: {
          uuid: activeAccount.data?.uuid,
          cloudAccountUpdate: {
            name,
            cloud_type: CloudProviders.AzureAd,
          },
        },
        onSuccess: () => navigate('/setup/accounts'),
      }),
    );
  };

  return (
    <>
      <Form
        title="Update Entra ID"
        iconType={CloudProviders.AzureAd}
        isTitleIconFilled={false}
        schema={{
          name: {
            type: 'text',
            label: 'Name',
            isRequired: true,
            defaultValue: activeAccount.data?.name,
            autoFocus: true,
          },
        }}
        styles={formStyles}
        buttonOptions={{
          submit: { name: 'OK', isLoading: activeAccount.isLoading },
          reset: {
            isVisible: true,
            onClick: handleReset,
          },
        }}
        handleSubmit={handleSubmit}
      />
    </>
  );
};
